export class NumberUtils {

    public static formatInThousands(x: number) {
        if (typeof x === undefined || isNaN(x) || x === null) {
            return " "
        }
        let formattedNumber: string = x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        if (x >= 1_000_000) {
            x = x / 1_000_000
            formattedNumber = Math.round(x * 100) / 100 + "M";
        } else if (x >= 1_000_000_000) {
            x = x / 1_000_000_000
            formattedNumber = Math.round(x * 100) / 100 + "B";
        } else if (x >= 1_000_000_000_000) {
            x = x / 1_000_000_000_000
            formattedNumber = Math.round(x * 100) / 100 + "TR";
        }
        return formattedNumber;
    }

    public static toFixed(x: number) {
        return x.toFixed(8);
    }
    
}